import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import OrderLogsArea from './OrderLogsArea.vue';
import Modal from '@/components/core/Modal/Modal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderLogsModal',
  props: /*@__PURE__*/_mergeModels({
    order: {}
  }, {
    "isOpen": { type: Boolean, ...{ default: false } },
    "isOpenModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["close"], ["update:isOpen"]),
  setup(__props: any, { emit: __emit }) {



const isOpenModel = _useModel<boolean>(__props, 'isOpen');

const emit = __emit;

function onClose() {
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    isOpen: isOpenModel.value,
    "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((isOpenModel).value = $event)),
    modalId: "order-logs-modal",
    title: "Logs",
    subtitle: __props.order ? `Order #${__props.order.id}` : undefined,
    maxWidth: "5xl",
    onClose: onClose
  }, {
    content: _withCtx(() => [
      (__props.order)
        ? (_openBlock(), _createBlock(OrderLogsArea, {
            key: 0,
            logs: __props.order.auditEvents
          }, null, 8, ["logs"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isOpen", "subtitle"]))
}
}

})